import React, { useState, useEffect } from "react";

import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    makeStyles,
    Paper,
    Slide,
    Snackbar,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesBA,
    useStylesCAB,
    useStylesContainers,
    useStylesHed,
    useStylesSN,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { stElemnt } from "../../../../St/comps/cStyle";

import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";

import clsx from "clsx";
import { insh as inshst } from "../../../../Context/InshSt";

import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { insh, sto } from "../../../../Context/InshData";

import toast, { Toaster } from "react-hot-toast";

import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { dfaultfilters } from "../../../../services/taswya-servece";
import { Alert } from "@material-ui/lab";
import IntermediateAccTable from "./IntermediateAccTable";
import IntermediateAccHead from "./IntermediateAccHead";
import IntermediateAccAppbar from "./IntermediateAccAppbar";
import AccountSearchModal from "../accounts-search-modal";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
        width: "100%",

    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function IntermediateAcc(props) {
    const { AutoOptions, isDialog } = props;


    const defaultTransvalue = {
        id: '',
        date: moment(new Date()).format('YYYY-MM-DD'),
        is_deleted: '',
        branch: { id: AutoOptions.Branches[0].id, name: AutoOptions.Branches[0].name },
        center: { id: -1, name: 'الكل' },
        acc: AutoOptions.MedAccounts[0],
    };
    const transsubvalue = {
        no: 0,
        id: 1,
        Intermediate_name: '',
        Intermediate_acc_no: 0,
        Intermediate_acc_no_old: 0,
        Intermediate_acc_name: 0,
        Intermediate_section: '',
        trans_code: '',
        order_id: '',
        branch: '',
        Intermediate_Name_Pro: 0,
    };

    const [rptParams, setRptParams] = React.useState(defaultTransvalue);
    const [valueAutosSub, setValueAutosSub] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [openSearchMdl, setOpenSearchMdl] = useState(false);


    const [paramsSubList, setParamsSubList] = useState([...AutoOptions.MedAccounts]);


    const [selectItems, setSelectItems] = useState(true);



    const [rptParamsSub, setRptParamsSub] = useState(transsubvalue);
    const [rptParamsSelect, setRptParamsSelect] = useState(transsubvalue);



    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [editing, setEditing] = useState(false);

    const [sum, setSum] = useState(false);

    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const clasCAB = useStylesCAB();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const his = useHistory();
    const [filters, setFilters] = useState(dfaultfilters);



    const [snack, setSnack] = React.useState(insh.Snack);
    const clasSN = useStylesSN();

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };
    const { vertical, horizontal, openSnak } = snack;
    const handCSnack = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        setSnack({ ...snack, openSnak: false });
    };

    // useEffect(() => {
    //     // console.log("units is", currUnitList)
    //     if (paramsSubList.length>1){
    //         setFetching(false);
    //     }
    // }, [paramsSubList]);

    const frontSnack = () => {
        return (
            <div className={clasSN.rootSN}>
                <Toaster />

                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={openSnak}
                    autoHideDuration={snack.time}
                    onClose={handCSnack}
                    key={vertical + horizontal}
                    className={clasSN.snackbarSN}
                >
                    <Alert onClose={handCSnack} severity={snack.severit}>
                        {" "}
                        {snack.text}{" "}
                    </Alert>
                </Snackbar>
            </div>
        );
    };


    const [uiElement, setUiElement] = useState({});



    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }

    // const viewHandle = async () => {

    //     setData([]);
    //     setFetching(true);
    //     await axios
    //         .get(
    //           uri+
    //             `AccountReports/RestrictionSearch?branch=${rptParams?.branch}
    //     &&doc_no2=${rptParams?.doc_no2}
    //     &&fDate=${rptParams?.dateFrom + ' ' + rptParams.timeFrom}
    //     &&tDate=${rptParams?.dateTo + ' ' + rptParams.timeTo}
    //     &&notes=${rptParams?.notes}
    //     &&center=${rptParams.center?.id}
    //     &&user=${rptParams?.user.id}
    //    &&type=${rptParams?.type}
    //     &&deptVal=${rptParams?.deptval}
    //     &&creditVal=${rptParams?.creditval}`
    //         )
    //         .then((res) => {
    //             setData(res.data);
    //             console.log(" the data is", res.data);
    //             setFetching(false);
    //         })
    //         .catch((err) => {
    //             setFetching(false);
    //             console.log(err);
    //             // toast.err("يوجد خطأ في الجلب");
    //             setData([]);
    //         });
    // };

    const getIntermeateAccounts = async (branch) => {
        const tb = {
            wait: true,
            AllMedAccounts: true,
            // Items: true,
            parms: {
                iempid: sto.empi,
                tname: "intermed",
                branch: branch,
                // takei: 1,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setParamsSubList([...res.data?.MedAccounts]);

            })
            .catch((error) => {
            });

    };


    const selectRow = (row) => {
        setEditing(true);
        setRptParamsSub({ ...row });
        setOpenSearchMdl(true);
    };

    const onChange = (value) => {
        // setObject({...object, [name]:value})

        let newData = {
            ...rptParamsSub, Intermediate_acc_no: value.id, Intermediate_acc_name: value.name,
            Intermediate_acc_no_old: rptParamsSub.Intermediate_acc_no
        }

        setEditing(false);
        const index = rptParamsSub?.no;
        const dataUpdate = [...paramsSubList];
        dataUpdate[index] = { ...newData };
        setParamsSubList([...dataUpdate]);
        setRptParamsSub(transsubvalue);
        setSelectItems(true);
    }


    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
        getIntermeateAccounts(newValue.id);
    };

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();

    };
    const cls = useRptAF();


    const [prevent, setPrevent] = useState(insh.prevents);

    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);

    const clasBA = useStylesBA();
    const [transition, setTransition] = React.useState(undefined);

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });
    const ButtonWitting = (prop) => {
        reloadGets();

    };
    const handNewItem = () => {
        getIntermeateAccounts(rptParams.branch.id);
        //const defaultTG = AutoOptions.tax_groups?.filter((t) => t.isDefault == true);
        setPrevent(insh.prevents);
        setRptParamsSub(transsubvalue);
        setSelectItems(false);
    };
    const timer = React.useRef();

    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "print") { handNewItem(); }
            else if (prop === "save") { handNewItem(); }
            else if (prop === "delete") { handNewItem(); }
            else {
                handNewItem();
            }
            setPrevent(true);
        }, 2000);
    };


    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", 1000);
        //handNewItem();
    };
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });



    const [openDw, setOpenDw] = useState(false);

    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenDw(true);
    };
    const handCloseDw = () => {
        setOpenDw(false);
    };


    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const addToBS = (props) => {
        if (paramsSubList.length > 0) {
            ButtonLoading("save");
            let transSub = paramsSubList?.map(x => {
                console.log("thre group is ", x);
                return {
                    id: x.id,
                    Intermediate_name: x?.Intermediate_name,
                    Intermediate_acc_no: x?.Intermediate_acc_no,
                    Intermediate_acc_no_old: x?.Intermediate_acc_no_old,
                    Intermediate_acc_name: x?.Intermediate_acc_name,
                    Intermediate_section: x?.Intermediate_section,
                    trans_code: x?.trans_code,
                    order_id: x?.order_id,
                    branch: x?.branch,
                    Intermediate_Name_Pro: x?.Intermediate_Name_Pro,
                }
            })
            const model = {
                _intermedateList: paramsSubList,
                _branch: rptParams.branch.id,
            };
            console.log("the curre data is ", model);
            axios
                .post(uri + "IntermedateAccounts", model)
                .then((res) => {
                    if (res.data?.data != null) {
                        // alert("رقم الباردكود موجود مسبقا");
                        ButtonSuccess(props, 3000);
                    } else {
                        ButtonSuccess(props, 3000);
                    }

                })
                .catch((res) => {
                    ButtonSuccess(props, 1000);
                    alert("تأكد من اختيار الحساب ");

                })
        } else {
            alert("تأكد من اختيار الحساب ");

        }

    };

    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            // Items: true,
            parms: {
                iempid: sto.empi,
                tname: "tswya",
                branch: sto.branchi
                // takei: 1,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setRptParams({
                    ...defaultTransvalue,
                    no: res.data.other.lastid,
                    branch: AutoOptions.Branches[0].id,
                    safe: AutoOptions.Safes[0].id,
                });
            })
            .catch((error) => {
            });
    };

    return (
        <div className={classes.root}>

            {!isDialog &&
                <Grid container item xs={12}>
                    <Typography
                        size="small"
                        className={classes.headerTitle}
                        color="primary"
                    >
                        {" الحسابات الوسيطة"}
                    </Typography>
                </Grid>
            }

            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.blue[50],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    {/* <SafesTransferFilter {...{ valueAutos, setValueAutos }} /> */}

                    <IntermediateAccHead
                        {...{
                            AutoOptions,
                            rptParams,
                            onChangeAutoData,
                        }}
                    />
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        spacing={1}
                    >

                    </Grid>
                </Container>
                {/* <br /> */}
                {/* <br /> */}
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                    }}
                >
                    <Grid container justifyContent="center">
                        <Grid item container justifyContent="center" xs={12}>
                            <BeatLoader loading={fetching} color={colors.blue[50]} />
                            {!fetching && (
                                <IntermediateAccTable
                                    {...{
                                        paramsSubList,
                                        rptParams,
                                        setParamsSubList,
                                        selectRow,
                                        openSearchMdl,
                                        setOpenSearchMdl,
                                    }}
                                />
                            )}
                        </Grid>

                    </Grid>

                </Container>
            </Typography>

            <IntermediateAccAppbar  {...{
                buttonClassnameSave,
                clasCAB,
                stElemnt,
                loading,
                clasBA,
                backHome,
                back,
                addToBS,
                setOpenDw,
            }} />
            <AccountSearchModal
                {...{
                    open: openSearchMdl,
                    handleClose: () => {
                        setOpenSearchMdl(false);
                    },
                    onSelectAccount: (account) => {
                        const value = {
                            id: account.barcode,
                            name: account.symbol,
                        };
                        // props.onChange(null, { name: "acc", value: value });
                        onChange(value);


                        setOpenSearchMdl(false);
                    },
                }}
            />
            {frontSnack()}
        </div>
    );
}
